module.exports = __webpack_public_path__ + "static/media/BeaconLogoWhiteAlt.64063e7d.svg";